import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { Button } from "reactstrap";
import { useTranslation } from "../../languages";
const PaginationControls = ({
  pages,
  next,
  previous,
  currentPageIndex,
  setCurrentPageIndex,
}) => {
  const getDisplayedPages = () => {
    let array = [];
    if (pages?.length < 10) {
      return pages;
    } else {
      array = [
        ...pages?.slice(0, 2),
        "...",
        ...pages?.slice(pages?.length - 3, pages?.length - 1),
      ];
      return array;
    }
  };

  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center items-pagination justify-content-between">
      <Button
        disabled={currentPageIndex === 0}
        onClick={() => previous()}
        style={{ border: "0.95px solid rgba(197, 197, 211, 1)" }}
        className="bg-transparent text-black d-flex align-items-center gap-2"
      >
        <FaArrowLeftLong size={20} />
        <div className="d-none d-md-block">{t("previous")}</div>
      </Button>
      <div className="d-flex align-items-center gap-1">
        {getDisplayedPages()?.map((item, index) => (
          <button
            onClick={() => setCurrentPageIndex(index)}
            className={`pagination-button ${
              currentPageIndex === index ? "active" : ""
            }`}
            key={`pagination-page-${index}`}
          >
            {item}
          </button>
        ))}
      </div>
      <Button
        disabled={currentPageIndex >= pages?.length - 1}
        onClick={() => next()}
        style={{ border: "0.95px solid rgba(197, 197, 211, 1)" }}
        className="bg-transparent text-black d-flex align-items-center gap-2 "
      >
        <div className="d-none d-md-block">{t("next")}</div>
        <FaArrowRightLong size={20} />
      </Button>
    </div>
  );
};

export default PaginationControls;
